import React from 'react'

const HomeCom3 = () => {
    return (
        <section className='flex space-between home-com-3'>
            <article>
                <header>Payment Value</header>
                <p>$6.13K</p>
            </article>
            <article>
                <header>Number of Payments</header>
                <p>2.12K</p>
            </article>
            <article>
                <header>Number of Refunds</header>
                <p>44</p>
            </article>
        </section>
    )
}

export default HomeCom3
